import { IACCNofiticationVm } from "../../../model/request/nofitication/IAccNofitication";
import { INofiticationRequest } from "../../../model/request/nofitication/INofiticationRequest";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eNotificationActionsObj = {
  CHANGE_REQUEST: {} as any,

  LOAD_START: {} as INofiticationRequest,
  LOAD_SUCCESS: {} as IACCNofiticationVm[],
  LOAD_ERRR: "",

  CHANGE_SHOW: false,
  CHANGE_READ_STATUS: "" as "all" | "unread",
};
export const eNotificationActionIds = generateActionTypeIds(
  eNotificationActionsObj,
  "NOFITICATION",
);
export type INotificationActionTypes = IGenericActionType<
  typeof eNotificationActionsObj,
  "NOFITICATION"
>;
